import { createSlice } from "@reduxjs/toolkit";
import { fetchFRTStock } from "./thunk";

interface FRTStockState {
  FirstStockList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: FRTStockState = {
  FirstStockList: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const FRTStockSlice = createSlice({
  name: "FRTStock",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFRTStock.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFRTStock.fulfilled, (state, action) => {
        state.loading = false;
        state.FirstStockList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchFRTStock.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Draft RFQ List";
      });
  },
});

export default FRTStockSlice.reducer;
